<template>
  <v-layout wrap style="height: 100px">
    <v-navigation-drawer v-model="enableFilters" persistent fixed width="600">
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  no-title
                  @input="menuStartAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  no-title
                  @input="menuEndAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <div>
            <v-subheader>Outros Filtros</v-subheader>
          </div>
          <v-layout>
            <kind />
          </v-layout>

          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  components: {
    kind: () => import("./options/kind.vue"),
  },
  data: (vm) => ({
    id: "",
    name: "",
    cpf: "",
    cnpj: "",
    startAt: null,
    endAt: null,
    startAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'start'),
    endAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'end'),
    menuStartAt: false,
    menuEndAt: false,
    enableFilters: false,
    positiveType: null,
  }),
  computed: {
    kindFilter: {
      get() {
        return this.$store.getters['wallet/kind'];
      },
      set(value) {
        this.$store.dispatch("wallet/kind", value);
      },
    },
    showFilters: {
      get() {
        return this.$store.getters['wallet/showFilters'];
      },
      set(value) {
        this.$store.dispatch("wallet/showFilters", value);
      },
    },
    ...mapGetters({
      filterParams: "wallet/filterParams",
      walletId: "wallet/walletId",
      extract: "wallet/all",
      totalResources: "wallet/totalResources",
      receiveds: "wallet/received",
      sendeds: "wallet/sended",
      limitOptions: "wallet/limitOptions",
      page: "wallet/page",
      isLoading: "wallet/loadingData",
    }),
    computedStartAtFormatted() {
      return this.formatDate(this.startAt, 'start');
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt, 'end');
    },
  },
  watch: {
    showFilters(newValue) {
      if (newValue) {
        this.enableFilters = newValue;
      }
    },
    startAt() {
      this.startAtFormatted = this.formatDate(this.startAt, 'start');
      this.$store.dispatch('wallet/updateStartAt', this.formatDate(this.startAtFormatted, 'start'));
    },
    endAt() {
      this.endAtFormatted = this.formatDate(this.endAt, 'end');
      this.$store.dispatch('wallet/updateEndAt', this.formatDate(this.endAtFormatted, 'end'));
    },
  },
  methods: {
    getResources() {
      const params = {
        page: this.page,
        limit: this.limitOptions[0] || 10,
        filterrific: {
          with_created_at_between: {
            start_at: this.formatDate(this.startAt, 'start'),
            end_at: this.formatDate(this.endAt, 'end'),
          },
          kind: this.kindFilter,
          positive: this.positiveType
        },
      };
      this.$store.dispatch("wallet/setFilterParams", params);
      this.$store.dispatch("wallet/getExtract", params);
      this.desableFilters();
    },
    desableFilters() {
      this.$store.dispatch("wallet/showFilters", false);
      this.enableFilters = false;
    },
    reset() {
      this.$store.dispatch("wallet/getExtract", this.filterParams);
      this.$store.dispatch("wallet/resetFilters");
      this.$store.dispatch("wallet/showFilters", false);
    },
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (kind == 'start') { 
        return `${day}/${month}/${year} 00:00:00`;
      } else {
        return `${day}/${month}/${year} 23:59:00`;
      }  
    }
  },
};
</script>
